import React from "react"
import Relay from "react-relay"
import Video from "react-html5video"
import {
  getVideoFromResource,
  getImageSrcFromResource,
  getVideoFromFile,
  getImageSrcFromFile,
  getImageType
} from "../../scripts/resource"
import MediaMissing from "./MediaMissing"

//TODO WTF, and TODO fix up webpack.config.babel.js and package.js when gone
if (typeof window !== "undefined") {
  require("react-html5video/src/assets/video.css")
}

class VideoView extends React.Component {
  render() {
    const { resource, file } = this.props
    const imageType = getImageType(file ? file.type : resource.type)
    const imageSrc = file
      ? getImageSrcFromFile(file, "medium", imageType, false)
      : getImageSrcFromResource(resource, "medium", imageType, false)
    const video = file ? getVideoFromFile(file) : getVideoFromResource(resource)

    return video ? (
      <div>
        {video.url && (
          <span className="hide for-schema-markup-only" itemProp="url">
            {video.url}
          </span>
        )}
        {video.url && (
          <Video controls poster={imageSrc || null}>
            <source src={video.url} type={video.mime_type} />
          </Video>
        )}
      </div>
    ) : (
      <MediaMissing resource={resource} file={file} />
    )
  }
}

export default Relay.createContainer(VideoView, {
  fragments: {
    resource: () => Relay.QL`
      fragment on Resource {
        type
        files {
          type
          images {
            medium { url }
          }
          video {
            med {
              url
              mime_type
            }
            low {
              url
              mime_type
            }
          }
        }
        ${MediaMissing.getFragment("resource")}
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/VideoView.js